<script>
  import { onDestroy } from 'svelte';

  import Modal from '@components/Modal.svelte';
  import Checkbox from '@components/Checkbox.svelte';
  import Dropdown from '@components/Dropdown.svelte';
  import Notification from '@utils/notification';

  import SectionAjax from '@ajax/section';
  import RecAjax from '@ajax/rec';

  import { getGroupStore } from '@stores/group';
  let recsStore = getGroupStore('recsStore');
  let groupStore = getGroupStore('groupStore');
  let sectionsStore = getGroupStore('sectionsStore');

  import AddSectionModal from './AddSectionModal.svelte';

  export let showModal = false;
  export let section;
  export let mobile = false;

  import jQuery from 'jquery';

  let group = groupStore;
  let sections = sectionsStore;
  let recs = recsStore;

  let unsubGroup = group.subscribe((x) => (group = x));
  let unsubSections = sections.subscribe((x) => (sections = x));
  let unsubRecs = recs.subscribe((x) => (recs = x));

  let deleting = false;
  let deleteItemsAction;

  $: totalRecObjects = section ? recsStore.distinctReduceCount({ section_id: section.id }, (x) => x.rec_object_id) : 0;

  let selectedSection = null;
  let selectedOption;
  let sectionOptions = [];
  let optionsVisible = false;
  let addSectionModal = false;
  let placeholder = 'Select a section';

  $: {
    sectionOptions = [];

    if (sections && section) {
      sections
        .sortBy((x) => x.position)
        .forEach((s) => {
          if (s && s.id != section.id) {
            sectionOptions.push({ label: s.name, value: s });
          }
        });
    }
  }

  let open = function () {
    if (sections.length == 1) {
      deleteItemsAction = 'keep-recs';
    } else {
      deleteItemsAction = 'move';
    }
  };

  let close = function () {
    placeholder = 'Select a section';
    showModal = false;
    deleting = false;
    selectedSection = null;
    selectedOption = undefined;
  };

  let deleteSection = async function () {
    let ss;
    let recIds = [];

    if (totalRecObjects > 0 && deleteItemsAction == 'move') {
      if (selectedSection == null) {
        Notification.send({
          text: 'Please select a section to move the recommendations',
          type: 'error',
        });
        return;
      }

      if (selectedSection) {
        ss = sections.find(selectedSection.id);
      }

      if (!ss) {
        Notification.send({
          text: "We couldn't move to this section. We will look into this issue!",
          type: 'error',
        });
        return;
      }
    }

    jQuery(`div[data-section-id='${section.id}']`).each(function () {
      jQuery(this)
        .find('div[data-rec-id]')
        .each(function () {
          recIds.push(jQuery(this).data('rec-id'));
        });
    });

    deleting = true;

    try {
      await SectionAjax.destroy(group, section, {
        move_section_id: ss && ss.id,
        item_action: deleteItemsAction,
        rec_ids: recIds,
      });

      sectionsStore.remove(section);
      recsStore.set(await RecAjax.fetch(group));
      close();
    } catch {}

    deleting = false;
  };

  var selectDeleteItemAction = function (action) {
    return function () {
      if (action == deleteItemsAction && sections.length == 1) {
        deleteItemsAction = 'keep-recs';
      } else {
        deleteItemsAction = action;
      }
    };
  };

  onDestroy(() => {
    unsubGroup();
    unsubSections();
    unsubRecs();
  });
</script>

<style style="text/scss" lang="scss">
  .ui-header {
    font-weight: 500;
    font-size: 16px;
  }

  .ui-section-name {
    margin-top: 60px;
    font-size: 25px;
    line-height: 26px;
    font-weight: 500;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }

  .ui-items {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      flex-shrink: 0;
      width: 15px;
      height: 15px;
    }

    .ui-items-label {
      padding-left: 10px;
      padding-right: 10px;
      font-weight: 500;
      font-size: 13px;
    }

    .ui-items-count {
      opacity: 0.5;
      font-size: 13px;
    }
  }

  .ui-actions {
    margin-top: 65px;
    max-width: 275px;
    margin-left: auto;
    margin-right: auto;

    .delete-btn {
      height: 48px;
      color: #ff5567;
      font-weight: 500;
      font-size: 14px;
      border: none;
      border-radius: 15px;
      background: #fde7e7;
      width: 275px;

      &:hover {
        color: #fff;
        background: #ff5567;
      }
    }

    .cancel-btn {
      color: #000;
      font-size: 15px;
      margin-top: 12px;
      font-weight: 500;
      border: none;
      background: transparent;
    }
  }

  * :global(.dropdown-button) {
    width: 100% !important;
    text-align: left !important;
    border: 2px solid #ececec !important;
    height: 38px !important;
    padding-top: 6px !important;
    font-weight: normal !important;
    border-radius: 10px !important;
  }

  * :global(.dropdown-options-option) {
    text-align: left !important;
    font-size: 15px !important;
  }

  * :global(.dropdown-options) {
    left: 2px !important;
    width: calc(100% - 4px) !important;
    margin-top: -10px !important;
  }
</style>

<AddSectionModal
  mobile={mobile}
  bind:showModal={addSectionModal}
  on:close={async (e) => {
    placeholder = undefined;
    selectedSection = e.detail.section;
    selectedOption = {
      label: selectedSection.name,
      value: selectedSection,
    };

    if (selectedSection) {
      deleteItemsAction = 'move';
    }
  }} />

<div class="svelte-modal">
  <Modal
    mobile={mobile}
    on:show={open}
    on:close={close}
    show={showModal}
    showCloseButton={false}
    fadeInDuration={200}
    style="border-radius: 16px; width: 490px">
    <div slot="content" style="text-align: center;">
      <div class="ui-header">Delete Section</div>
      <div class="ui-section-name">{section.name}</div>

      <div class="ui-items">
        <img src="/emojis/purple_star.png" />
        <div class="ui-items-label">Items</div>
        <div class="ui-items-count">{totalRecObjects}</div>
      </div>

      {#if totalRecObjects > 0}
        <div
          style="display: flex; margin-top: 40px; max-width: 250px; margin-left:
        auto; margin-right: auto;">
          {#if sections.length > 1}
            <div>
              <Checkbox checked={deleteItemsAction == 'move'} on:change={selectDeleteItemAction('move')} />
            </div>
            <div style="display: flex; flex-direction: column; margin-left: 13px;">
              <div style="opacity: 0.75; cursor: pointer; text-align: left" on:click={selectDeleteItemAction('move')}>
                Move {totalRecObjects}
                {totalRecObjects == 1 ? 'item' : 'items'}
                in this section to
              </div>
              <div style="margin-top: 10px; width: 217px;">
                <Dropdown
                  bind:placeholder={placeholder}
                  disabled={deleteItemsAction == 'delete'}
                  bind:optionsVisible={optionsVisible}
                  bind:selectedOption={selectedOption}
                  showSelectedOption={false}
                  options={sectionOptions}
                  on:selected={(e) => {
                    selectedSection = e.detail.option.value;
                  }}>
                  <div slot="additional-options" style="padding-top: 8px; padding-bottom: 8px; text-align: left;">
                    <a
                      href="#"
                      style="color: #a893f9; font-size: 13px;"
                      on:click={() => {
                        addSectionModal = true;
                        optionsVisible = false;
                      }}>
                      <i class="fa fa-plus" style="zoom: 0.8" />
                      <span style="margin-left: 7px">Add new section</span>
                    </a>
                  </div>
                </Dropdown>
              </div>
            </div>
          {/if}
        </div>

        <div
          style="display: flex; margin-top: 20px; max-width: 250px; margin-left:
        auto; margin-right: auto;">
          <div>
            <Checkbox checked={deleteItemsAction == 'delete'} on:change={selectDeleteItemAction('delete')} />
          </div>
          <div
            style="opacity: 0.75; cursor: pointer; margin-left: 13px; text-align:
          left;"
            on:click={selectDeleteItemAction('delete')}>
            {sections.length == 1 ? 'Also delete' : 'Delete'}
            {totalRecObjects}
            {totalRecObjects == 1 ? 'item' : 'items'}
            in this section
          </div>
        </div>
      {/if}

      <div class="ui-actions">
        <button class="delete-btn" on:click|preventDefault={deleteSection}>
          {#if deleting}
            <div>
              <i class="fa fa-spin fa-spinner" />
              <span style="margin-left: 10px;">Removing section</span>
            </div>
          {:else if totalRecObjects == 0 || deleteItemsAction == 'keep-recs'}
            Delete section
          {:else if deleteItemsAction == 'move'}
            Move items and delete section
          {:else}Delete items and section{/if}
        </button>
        <button class="cancel-btn" on:click|preventDefault={close}>Cancel</button>
      </div>
    </div>
  </Modal>
</div>
